'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InfoPartition = require('../InfoPartition/InfoPartition');

var _InfoPartition2 = _interopRequireDefault(_InfoPartition);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VatPolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VatPolicy, _Component);

  function VatPolicy() {
    (0, _classCallCheck3.default)(this, VatPolicy);
    return (0, _possibleConstructorReturn3.default)(this, (VatPolicy.__proto__ || (0, _getPrototypeOf2.default)(VatPolicy)).apply(this, arguments));
  }

  (0, _createClass3.default)(VatPolicy, [{
    key: 'render',


    /* eslint-disable max-len */
    value: function render() {
      var t = this.props.t;

      var text = {
        title: t('VAT Policy'),
        preKey: 'vat-policy_',
        body: t('In accordance with the sales tax regulations of European Union countries in which our Residents live, we must collect and remit Value Added Tax, or VAT, from Residents.'),
        articles: [{
          key: 'charged-vat_',
          header: t('Who should be charged VAT?'),
          bodies: [t('Currently, only Residents who live in the European Union are charged VAT. The EU allows people and companies to register for VAT exemption, which we abide by.')]
        }, {
          key: 'determinate_',
          header: t('How does CRight determine who to charge VAT for?'),
          bodies: [t('When you registered your account, you told us what country you live in. If that country is in the EU, then VAT is applied.'), t('If you say that you come from a different country that doesn\'t charge VAT, it\'s very likely that discrepancies between your IP address and your declared country would get caught in our risk detection system and may cause your account to be flagged for review or even suspended.')]
        }, {
          key: 'charged-items_',
          header: t('How can I tell what items had VAT charged?'),
          bodies: [t('Your account history page will display the transactions you made and the VAT charged on each one, if applicable.')]
        }, {
          key: 'exempt-vat_',
          header: t('I have a VAT registration ID that makes me exempt from VAT. How do I enter it?'),
          bodies: [t('If you\'re registering for a new account, there\'s a step where you can enter your VAT registration ID.'), t('If you have an existing account for which you want to enter your VAT registration ID, click here to enter it.')]
        }]
      };

      return _react2.default.createElement(_InfoPartition2.default, { text: text });
    }
    /* eslint-enable max-len */

  }]);
  return VatPolicy;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = VatPolicy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/VatPolicy/VatPolicy.js
// module id = 2027
// module chunks = 1